import { render, staticRenderFns } from "./WeChatApplicationRecord.vue?vue&type=template&id=1d7c71d2&scoped=true"
import script from "./WeChatApplicationRecord.vue?vue&type=script&lang=js"
export * from "./WeChatApplicationRecord.vue?vue&type=script&lang=js"
import style0 from "./WeChatApplicationRecord.vue?vue&type=style&index=0&id=1d7c71d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c71d2",
  null
  
)

export default component.exports